import React, { useEffect } from 'react';
import { HashRouter } from 'react-router-dom';
import MicroForm from './components/MicroForm';
import Footer from './components/Footer';
import HubspotScript from './components/HubspotScript';
import GoogleTagManager from './components/GoogleTagManager';
import AwsRumScript from './components/AwsRumScript';
import TrustpilotScript from './components/TrustpilotScript';
import VwoScript from './components/VwoScript';
import { consentManager } from './utils/consentManager';
import { clientConfig } from './config/clientConfig';
import './utils/consentDebugger'; // Load debugger utility for development

function App() {
  useEffect(() => {
    // Global button click handler for implicit consent (California users)
    const handleButtonClick = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      const button = target.closest('button');
      
      if (button && !consentManager.hasInteracted()) {
        consentManager.recordInteraction();
        
        if (clientConfig.isDebugEnabled) {
          console.log('📝 User interaction recorded - GTM will load for CA users');
        }
      }
    };

    // Use capture phase to catch clicks before they're handled by other listeners
    document.addEventListener('click', handleButtonClick, true);

    return () => {
      document.removeEventListener('click', handleButtonClick, true);
    };
  }, []);

  return (
    <HashRouter>
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-4 px-4 sm:px-6">
        <VwoScript />
        <TrustpilotScript />
        <MicroForm />
        <Footer />
        <HubspotScript />
        <GoogleTagManager />
        <AwsRumScript />
      </div>
    </HashRouter>
  );
}

export default App;